import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, {useId} from 'react';

import styles from './styles.module.scss';

const propTypes = {
  id: PropTypes.string,
  variant: PropTypes.string
};

const RatingStars = ({id, variant}) => {
  const generatedId = useId();
  const _id = id || generatedId;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="92"
      height="13"
      fill="none"
      className={classNames(styles.stars, {
        [styles[`stars--${variant}`]]: variant !== undefined
      })}>
      <path
        fillRule="evenodd"
        d="M6.5 0L4.49 4.28 0 4.966l3.25 3.33L2.483 13 6.5 10.78 10.517 13 9.75 8.297 13 4.966 8.509 4.28 6.499 0zm21 0l-2.01 4.28-4.49.686 3.25 3.33L23.483 13l4.017-2.22L31.517 13l-.767-4.703L34 4.966l-4.491-.686L27.499 0zm19 0l-2.01 4.28-4.49.686 3.25 3.33L42.483 13l4.017-2.22L50.517 13l-.767-4.703L53 4.966l-4.491-.686L46.499 0zm19 0l-2.01 4.28-4.49.686 3.25 3.33L61.483 13l4.017-2.22L69.517 13l-.767-4.703L72 4.966l-4.491-.686L65.499 0zm19.365 0l-1.993 4.279-4.46.686 3.227 3.33-.761 4.703 3.987-2.22 3.989 2.22-.762-4.703 3.227-3.33-4.459-.686L84.865 0z"
        clipRule="evenodd"
        className={styles.stars__path}
      />
      <mask id={_id} width="14" height="13" x="78" y="0" maskUnits="userSpaceOnUse">
        <path
          fillRule="evenodd"
          d="M84.865 0l-1.993 4.279-4.46.686 3.227 3.33-.761 4.703 3.987-2.22 3.989 2.22-.762-4.703 3.227-3.33-4.459-.686L84.865 0z"
          clipRule="evenodd"
          fill="#fff"
        />
      </mask>
      <g mask={`url(#${_id})`}>
        <path
          d="M84.76-6.842h14.197v23.947H84.76z"
          opacity="0.505"
          className={styles.stars__last}
        />
      </g>
    </svg>
  );
};

RatingStars.propTypes = propTypes;

export default RatingStars;
